import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useActiveTemplateId } from './use-active-project-template';
const getAllAllocations = ()=>createSelector((state)=>state.templates.project, (_, templateId)=>templateId, (project, templateId)=>project.data[templateId].allocations);
export const useGetAllAllocations = ()=>{
    const templateId = useActiveTemplateId();
    const templateObject = useMemo(getAllAllocations, []);
    return useSelector((state)=>templateObject(state, templateId));
};
